import React from "react";
import { useNavigate } from "react-router-dom";

const GENERATED_STEPS = [
  { key: "specs", label: "Survey Specifications", path: "/add-survey" },
  { key: "robustness", label: "Survey Size", path: "/survey-robustness" },
  { key: "generated", label: "Questions", path: "/generated-survey" },
];

const AUDIENCE_STEP = {
  key: "audience",
  label: "Audience",
  path: "/define-audience",
};

const PRICING_STEP = {
  key: "pricing",
  label: "Pricing",
  path: "/pricing",
};

const UPLOADED_STEPS = [
  { key: "upload", label: "Upload Survey", path: "/create-survey" },
  AUDIENCE_STEP,
  PRICING_STEP,
];

function stepOrder(flow, isAuthenticated) {
  if (flow === "uploaded") {
    return UPLOADED_STEPS;
  }

  return isAuthenticated
    ? [...GENERATED_STEPS, AUDIENCE_STEP]
    : [...GENERATED_STEPS, AUDIENCE_STEP, PRICING_STEP];
}

function pillKeyFor(flow, activeStep, isAuthenticated) {
  if (flow === "generated" && activeStep === "audience" && !isAuthenticated)
    return "generated";
  return activeStep;
}

export default function Horizontalstepper({
  flow = "generated",
  activeStep,
  isAuthenticated = false,
  maxStepReached,
  onNavigate,
}) {
  const navigate = useNavigate();
  const steps = stepOrder(flow, isAuthenticated);
  const allSteps = steps;

  const activeKey = pillKeyFor(flow, activeStep, isAuthenticated);
  const maxKey = pillKeyFor(
    flow,
    maxStepReached || activeStep,
    isAuthenticated,
  );

  const activeIndex = allSteps.findIndex((s) => s.key === activeKey);
  const maxIndex = allSteps.findIndex((s) => s.key === maxKey);
  const reachableIndex =
    maxIndex === -1 ? activeIndex : Math.max(activeIndex, maxIndex);

  const handleClick = (step, index) => {
    if (index > reachableIndex) return;
    if (activeStep === step.key) return;
    if (typeof onNavigate === "function") {
      onNavigate(step.key);
      return;
    }
    navigate(step.path);
  };

  return (
    <nav className="survey-flow-nav" aria-label="Survey creation progress">
      {allSteps.map((step, index) => {
        const isActive = index === activeIndex;
        const isDisabled = index > reachableIndex;
        return (
          <React.Fragment key={step.key}>
            <button
              type="button"
              className={`survey-flow-nav__step${
                isActive ? " survey-flow-nav__step--active" : ""
              }${isDisabled ? " survey-flow-nav__step--disabled" : ""}`}
              onClick={() => handleClick(step, index)}
              disabled={isDisabled}
              aria-current={isActive ? "step" : undefined}
            >
              {step.label}
            </button>
            {index < allSteps.length - 1 && (
              <span className="survey-flow-nav__chevron" aria-hidden="true">
                &gt;
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
